import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DataTable from "react-data-table-component";
import React, { useState, useEffect, useMemo } from "react";
import { executiveNamesList, executiveNamesList1, executiveNamesList2 } from "./data";
import config from "../../../common/config";
import FilterComponent from "../../../Components/datatable/filter";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import NoResultData from "../../../Components/datatable/no-result";

const TableCheckBox = React.forwardRef(({ onClick, ...rest }, ref) => (
  <div className="form-check form-check-size-16">
    <input
      htmlFor="booty-check"
      type="checkbox"
      className="form-check-input"
      ref={ref}
      onClick={onClick}
      {...rest}
    />
    <label className="form-check-label" id="booty-check" />
  </div>
));

const PaymentReport = () => {
  const [statusRide5, setstatusRide5] = useState("");
  const [paymentstatus5, setPaymentStatus5] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [status, setStatus] = useState();
  const [status1, setStatus1] = useState();
  const [status2, setStatus2] = useState();
  const [query, setquery] = useState("");
  const [reportDetails, setReportDetails] = useState("");
  const [totalpages, setTotalpages] = useState("");
  const [perpage, setPerPage] = useState(10);
  const [totalcount, setTotalcount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [reportdaterange, setReportDateRange] = useState([]);
  const [drivers, setDrivers] = useState("");

  const userType = localStorage.getItem("userType");
  const userType2 = localStorage.getItem("userType");
  const loginhotelname = localStorage.getItem("hotelname");
  const hotelname = localStorage.getItem("hotelname");

  const [hotelList, setHotelList] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState("");

  const selectedOption = executiveNamesList2[0].options[1].value;

  useEffect(() => {
    fetchDrivers();
    callAPI();
  }, []);

  // Fetch report when page number changes
  useEffect(() => {
    fetchReportData(pageNumber, perpage);
  }, [pageNumber]);

  // Centralized API fetcher maintaining all selected filter states
  const fetchReportData = async (targetPage = pageNumber, targetLimit = perpage) => {
    let fromDate = "";
    let toDate = "";

    if (reportdaterange.length === 2) {
      fromDate = reportdaterange[0];
      toDate = reportdaterange[1];
    } else if (reportdaterange.length === 1) {
      fromDate = reportdaterange[0];
      toDate = reportdaterange[0];
    }

    const requestBody = {
      query: query,
      confirmation_status: "0",
      ride_status: statusRide5,
      payment_status: paymentstatus5,
      payment_type: userType === "2" ? "hotel" : paymentType,
      hotel_name:
        userType === "1"
          ? selectedHotel
            ? selectedHotel.label
            : ""
          : hotelname,
      from: fromDate,
      to: toDate,
      page: targetPage,
      limit: targetLimit,
    };

    try {
      const response = await fetch(config.baseUrl + "api/report/payment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (response.status === 200) {
        setReportDetails(data.data || []);
        setTotalpages(data.totalPages || 0);
        setTotalcount(data.totalCount || 0);
      }
    } catch (error) {
      console.error("Error fetching payment report:", error);
    }
  };

  const handlequeryChange = (event) => {
    setquery(event.target.value);
  };

  const options = {
    mode: "range",
    onChange: (selectedDates, dateStr) => {
      const myArray = dateStr.split(" to ");
      setReportDateRange(myArray);
    },
  };

  function changeStatus(e) {
    setStatus(e.value);
    const value = e.value;

    if (value === "All Status") {
      setstatusRide5("0");
    } else if (value === "Not Yet") {
      setstatusRide5("1");
    } else if (value === "Completed") {
      setstatusRide5("2");
    } else {
      setstatusRide5("");
    }
  }

  function changeStatus1(e) {
    setStatus1(e.value);
    const value = e.value;

    if (value === "All Status") {
      setPaymentStatus5("all");
    } else if (value === "Paid") {
      setPaymentStatus5("paid");
    } else if (value === "UnPaid") {
      setPaymentStatus5("unpaid");
    } else {
      setPaymentStatus5("");
    }
  }

  function changeStatus2(e) {
    setStatus2(e.value);
    const value = e.value;

    if (value === "All Status") {
      setPaymentType("all");
    } else if (value === "Hotel") {
      setPaymentType("hotel");
    } else if (value === "Driver") {
      setPaymentType("driver");
    } else {
      setPaymentType("");
    }
  }

  const getType = (type) => {
    if (type === "1" || type === "Arrival") {
      return "Airport Arrival";
    } else if (type === "2") {
      return "Airport Departure";
    } else if (type === "3") {
      return "Point To Point(Transfer)";
    } else if (type === "4") {
      return "Singapore Disposal";
    } else {
      return "Malaysia Disposal";
    }
  };

  const getDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    const dateObject = new Date(year, month - 1, day);
    const monthName = dateObject.toLocaleString("default", { month: "short" });
    return `${parseInt(day, 10)} ${monthName}, ${year}`;
  };

  const callAPI = async () => {
    try {
      const response = await fetch(config.baseUrl + "api/admin/hotellist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          page: 1,
          limit: "all",
        }),
      });
      const data = await response.json();
      setHotelList(data.data || []);
    } catch (error) {
      console.error("Failed to fetch hotel list:", error);
    }
  };

  const activeHotels = hotelList.filter((hotel) => hotel.status === 1);
  const hotelOptions =
    hotelList &&
    activeHotels.map((hotel) => ({
      value: hotel._id,
      label: hotel.hotel_name,
    }));

  const handleHotelChange = (selectedOption) => {
    setSelectedHotel(selectedOption);
  };

  const getBookingPerson = (bookingHistory) => {
    let bookperson = null;
    if (bookingHistory && bookingHistory.length > 0) {
      bookperson = bookingHistory.find(
        (history) => history && "Booking Requested" in history
      );
    }

    if (bookperson) {
      const bookingperson = bookperson["Booking Requested"];
      return bookingperson["Booking Person"] || "";
    }

    return "";
  };

  const getDriverDetails = (id) => {
    if (id !== undefined && id !== null && drivers) {
      const driverArrray = Object.values(drivers);
      const driver = driverArrray.find((obj) => obj._id === id);
      return driver?.phone_number || "";
    }
    return "";
  };

  const getDriverDetails1 = (id) => {
    if (id !== undefined && id !== null && drivers) {
      const driverArrray = Object.values(drivers);
      const driver = driverArrray.find((obj) => obj._id === id);
      return driver?.car_number || "";
    }
    return "";
  };

  const fetchDrivers = async () => {
    try {
      const response = await fetch(config.baseUrl + "api/admin/driverlist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          page: 1,
          limit: "all",
        }),
      });
      const data = await response.json();
      setDrivers(data.data);
    } catch (error) {
      console.error("Failed to fetch drivers:", error);
    }
  };

  const handleSubmit = async () => {
    if (pageNumber === 1) {
      fetchReportData(1, perpage);
    } else {
      setPageNumber(1);
    }
  };

  const handleCancel = () => {
    window.location.reload();
  };

  const handlePageChange = async (newPage) => {
    setPageNumber(newPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setPageNumber(page);
    fetchReportData(page, newPerPage);
  };

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL",
  };

  function getbookstatus(value) {
    if (value === 2) {
      return "ACCEPTED";
    } else if (value === 1) {
      return "REQUESTED";
    } else if (value === 3) {
      return "CANCELLED";
    }
    return "";
  }

  function getridestatus(value) {
    if (value === "2") {
      return "COMPLETED";
    } else if (value === "1") {
      return "NOT YET";
    }
    return "";
  }

  function statusIdentification(array) {
    if (!Array.isArray(array)) return;
    for (var j = 0; j < array.length; j++) {
      if (array[j].confirmation_status === 1) {
        array[j].confirmation_status1 = "Requested";
        array[j].confirmationNameColor = "warning";
      } else if (array[j].confirmation_status === 2) {
        array[j].confirmation_status1 = "Accepted";
        array[j].confirmationNameColor = "success";
      } else {
        array[j].confirmation_status1 = "Cancelled";
        array[j].confirmationNameColor = "danger";
      }
    }
  }

  function RidestatusIdentification(array) {
    if (!Array.isArray(array)) return;
    for (var k = 0; k < array.length; k++) {
      if (array[k].ride_status === "1") {
        array[k].ride_status1 = "Not yet";
        array[k].rideNameColor = "danger";
      } else {
        array[k].ride_status1 = "Completed";
        array[k].rideNameColor = "success";
      }
    }
  }

  function PaymentstatusIdentification(array) {
    if (!Array.isArray(array)) return;
    for (var l = 0; l < array.length; l++) {
      if (array[l].hotel_payment === 0) {
        array[l].hotel_payment1 = "Unpaid";
        array[l].paymentNameColor = "danger";
      } else if (array[l].hotel_payment === 1) {
        array[l].hotel_payment1 = "Paid";
        array[l].paymentNameColor = "success";
      } else {
        array[l].hotel_payment1 = "Unpaid";
        array[l].paymentNameColor = "danger";
      }
    }
  }

  function DriverpaymentstatusIdentification(array) {
    if (!Array.isArray(array)) return;
    for (var s = 0; s < array.length; s++) {
      if (array[s].driver_payment === 0) {
        array[s].driver_payment1 = "Unpaid";
        array[s].driverpaymentNameColor = "danger";
      } else if (array[s].driver_payment === 1) {
        array[s].driver_payment1 = "Paid";
        array[s].driverpaymentNameColor = "success";
      } else {
        array[s].driver_payment1 = "Unpaid";
        array[s].driverpaymentNameColor = "danger";
      }
    }
  }

  const formatMobileNumber = (number) => {
    return typeof number === "number" ? number.toString() : number;
  };

  const reportData = Object.values(reportDetails || {});

  const exceldata = reportData.map((obj, index) => {
    let travelInfo = "";

    if (obj.pickup_type === "1") {
      travelInfo = `Pickup Airport: ${obj.airport_name}\nDrop Location: ${obj.destination}\nFlight Number: ${obj.flight_number}`;
    } else if (obj.pickup_type === "2") {
      travelInfo = `Pickup Location: ${obj.destination}\nDrop Airport: ${obj.airport_name}\nFlight Number: ${obj.flight_number}`;
    } else if (
      obj.pickup_type === "3" ||
      obj.pickup_type === "4" ||
      obj.pickup_type === "5"
    ) {
      travelInfo = `Pickup Location: ${obj.pickup_location}\nDrop Location: ${obj.dropoff_location}`;
    }
    return {
      "Sr. No": index + 1,
      "Booking ID": obj.booking_id,
      "Hotel Name": obj.hotel_name,
      "Booking Person Name": getBookingPerson(obj.booking_history),
      "Booking Date & Time": obj.booking_date,
      "Booking Info": `Passenger Name:\n${obj.passenger_name}\n${obj.country_code} ${formatMobileNumber(obj.passenger_contact_number)}\nPassenger Seat: ${obj.number_of_passengers?.adult}\nBaby Seat: ${obj.number_of_passengers?.child}\nLuggage: ${obj.number_of_luggage}`,
      "Travel Date & Time": ` ${getDate(obj.date)} - ${obj.time}`,
      "Travel Type": getType(obj.pickup_type),
      "Travel Info": travelInfo,
      Car: ` ${obj.car_info?.car_brand} - ${obj.car_info?.car_model}`,
      "Assign Driver": `${obj.confirmation_status === 2 ? obj.driver_name : ""}\n${obj.confirmation_status === 2 ? "+65 " + getDriverDetails(obj.driver_id) : ""}${obj.confirmation_status === 2 ? "\nCar Plate No:" + getDriverDetails1(obj.driver_id) : ""}`,
      "Confirmation Date & Time": obj.confirmation_date,
      "Booking Status": getbookstatus(obj.confirmation_status),
      "Ride status": getridestatus(obj.ride_status),
      "Payment Info": `${obj.payment_info?.disposal_charge > 0 && typeof obj.payment_info?.disposal_charge !== "undefined" ? "\nDisposalCharge: $" + obj.payment_info.disposal_charge : ""}${obj.payment_info?.extra_disposal_charge > 0 && typeof obj.payment_info?.extra_disposal_charge !== "undefined" ? "\nExtraDisposal Charge: $" + obj.payment_info.extra_disposal_charge : ""}${obj.payment_info?.midnight_charge > 0 && typeof obj.payment_info?.midnight_charge !== "undefined" ? "\nMidnightCharge: $" + obj.payment_info.midnight_charge : ""}${obj.payment_info?.waiting_minutes_charge > 0 && typeof obj.payment_info?.waiting_minutes_charge !== "undefined" ? "\nWaitingCharge: $" + obj.payment_info.waiting_minutes_charge : ""}${obj.payment_info?.arrival_charge > 0 && typeof obj.payment_info?.arrival_charge !== "undefined" ? "\nArrivalCharge: $" + obj.payment_info.arrival_charge : ""}${obj.payment_info?.extra_stop_charge > 0 && typeof obj.payment_info?.extra_stop_charge !== "undefined" ? "\nExtra Stop Charge: $" + obj.payment_info.extra_stop_charge : ""}${obj.payment_info?.point_point_charge > 0 && typeof obj.payment_info?.point_point_charge !== "undefined" ? "\nPointtopoint Charge: $" + obj.payment_info.point_point_charge : ""}${obj.payment_info?.departure_charge > 0 && typeof obj.payment_info?.departure_charge !== "undefined" ? "\nAirportDeparture: $" + obj.payment_info.departure_charge : ""}${obj.surcharge_percentage ? "\nSurcharge Percentage: " + obj.surcharge_percentage * 25 + "%" : ""}`,
      "Payment Total": obj.payment_info?.total,
      "Driver Payment Remarks":
        obj.driver_payment_remark && !isNaN(obj.driver_payment_remark)
          ? parseInt(obj.driver_payment_remark)
          : obj.driver_payment_remark,
      "Booking Remarks": obj.remark || "",
      "Additional Remarks": obj.hotel_payment_remark || "",
    };
  });

  const columns = [
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Booking ID</span>,
      selector: (row) => row.booking_id,
      cell: (row) => <div className="fw-medium">{row.booking_id}</div>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Booking Info</span>,
      selector: (row) => row.booking_info,
      cell: (row) => (
        <div>
          <h5 className="fs-14 mb-1">{row.passenger_name}</h5>
          <p className="text-secondary fw-medium mb-0">
            {row.country_code} {row.passenger_contact_number}
          </p>
          {row.number_of_passengers && (
            <div>
              <p className="text-muted mb-0 mt-3">
                <span className="table-label">Passenger Seat : </span>{" "}
                <span className="fw-medium text-dark">
                  {row.number_of_passengers.adult}
                </span>
              </p>
              {row.number_of_passengers.child ? (
                <p className="text-muted mb-0">
                  <span className="table-label">Baby Seat : </span>{" "}
                  <span className="fw-medium text-dark">
                    {row.number_of_passengers.child}
                  </span>
                </p>
              ) : null}
              <p className="text-muted mb-0">
                <span className="table-label">Luggage : </span>{" "}
                <span className="fw-medium text-dark">
                  {row.number_of_luggage}
                </span>
              </p>
            </div>
          )}
          {userType !== "2" && userType !== "3" && (
            <p className="text-muted mb-0 mt-3">
              <span className="table-label">Hotel Name : </span>
              <span className="fw-medium text-dark d-block">
                {row.hotel_name}
              </span>
            </p>
          )}
          <p className="text-muted mb-0">
            <span className="table-label">Booking Person: </span>
            <span className="fw-medium text-dark d-block">
              {getBookingPerson(row.booking_history)}
            </span>
          </p>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Travel Info</span>,
      selector: (row) => row.data,
      width: "300px",
      cell: (row) => (
        <div>
          {row.pickup_type && (
            <div>
              <h5 className="fs-14 mb-1">{getType(row.pickup_type)}</h5>

              {row.pickup_type !== "3" &&
                row.pickup_type !== "4" &&
                row.pickup_type !== "5" && (
                  <p className="text-muted mb-0 mt-2">
                    <span className="table-label d-block">Destination </span>
                  </p>
                )}
              {row.pickup_type !== "3" &&
                row.pickup_type !== "4" &&
                row.pickup_type !== "5" && (
                  <h5 className="fs-14 mb-1 text-dark">
                    <span className="">{row.destination}</span>
                  </h5>
                )}
              {row.flight_number ? (
                <p className="text-muted mb-0 mt-2">
                  <span className="table-label">Flight Number : </span>
                  <span className="fw-medium text-dark">
                    {row.flight_number}
                  </span>
                </p>
              ) : null}

              {getType(row.pickup_type) !== "Airport Arrival" &&
                getType(row.pickup_type) !== "Airport Departure" &&
                row.pickup_location && (
                  <div className="d-flex align-items-center gap-1 mt-2">
                    <span className="text-muted table-label">
                      Pickup Location:{" "}
                    </span>
                    <span
                      className="fw-medium text-dark ellipsis"
                      title={row.pickup_location}
                    >
                      {row.pickup_location}
                    </span>
                  </div>
                )}

              {row.dropoff_location ? (
                <div className="d-flex align-items-center gap-1 mt-2">
                  <span className="text-muted table-label">
                    Drop Location :{" "}
                  </span>
                  <span
                    className="fw-medium text-dark ellipsis"
                    title={row.dropoff_location}
                  >
                    {row.dropoff_location}
                  </span>
                </div>
              ) : null}
              {row.extra_stop ? (
                <p className="text-muted mb-0 mt-0 mb-2">
                  <span className="table-label">Extra Stop : </span>
                  <span className="fw-medium text-dark">
                    {row.extra_stop}
                  </span>
                </p>
              ) : null}
              {row.pickup_type === "4" && (
                <p className="text-muted mb-0 mt-0">
                  <span className="table-label">Disposal Hours:</span>
                  <span className="fw-medium text-dark">
                    {row.disposal_hours}
                  </span>
                </p>
              )}
              {row.pickup_type === "5" && (
                <p className="text-muted mb-0 mt-0">
                  <span className="table-label">Disposal Hours:</span>
                  <span className="fw-medium text-dark">
                    {row.disposal_hours}
                  </span>
                </p>
              )}
              {row?.remark ? (
                <p className="text-muted mb-0 mt-1">
                  Remarks:{" "}
                  <span
                    className="fw-medium text-dark d-block ellipsis"
                    title={row?.remark}
                  >
                    {row?.remark}
                  </span>
                </p>
              ) : null}
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Travel Date & Time</span>,
      selector: (row) => row.bookingID,
      cell: (row) => (
        <div>
          <h5 className="fs-14 mb-1">{getDate(row.date)}</h5>
          <p className="text-muted mb-0 mt-0">
            <span className="d-inline">Time:</span>
            <span className="fs-14 text-dark d-inline">{row.time}</span>
          </p>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Car Info</span>,
      selector: (row) => row.carInfo,
      cell: (row) => (
        <div>
          <h5 className="fs-14 mb-1 text-nowrap">
            {row.car_info?.car_brand} {"-"} {row.car_info?.car_model}
          </h5>
          {row.confirmation_status === 2 && row.driver_name && (
            <div>
              <p className="text-muted mb-0 mt-3">
                Assign Driver:
                <span className="fw-medium d-block text-dark text-uppercase">
                  {row.driver_name}
                </span>
              </p>
              <p className="text-secondary fw-medium mb-0">
                +65 {getDriverDetails(row.driver_id)}
              </p>
            </div>
          )}
          {row.confirmation_status === 2 && row.driver_name && (
            <div>
              <p className="text-muted mb-0 mt-3">Car Plate No:</p>
              <p className="fw-medium d-block text-dark text-uppercase">
                {getDriverDetails1(row.driver_id)}
              </p>
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Booking Status</span>,
      selector: (row) => row.confirmation_status,
      cell: (row) => <div>{row.confirmation_status1}</div>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Date & Time Info</span>,
      selector: (row) => row.travelDateAndTime,
      cell: (row) => (
        <div className="text-muted mb-0 mt-0">
          <span className="d-block">Booking Date: </span>
          <span className="fw-medium text-dark d-block text-nowrap">
            {row.booking_date}
          </span>

          {row.confirmation_status === 2 && (
            <div>
              <p className="text-muted mb-0 mt-3">Confirmation Date:</p>
              <p className="text-dark mb-0"> {row.confirmation_date} </p>
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Ride Status</span>,
      selector: (row) => row.ride_status,
      cell: (row) => <div>{row.ride_status1}</div>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13 text-nowrap">Payment Info</span>,
      selector: (row) => row.paymentInfo,
      cell: (row) => (
        <div>
          <div className="d-flex align-items-center">
            <div className="flex-grow-1">
              <h5 className="fs-14 mb-1">
                <span className="text-muted fs-12 fw-medium">Total:</span>{" "}
                <span className="text-dark">${row.payment_info?.total}</span>
              </h5>
              {row.payment_info?.pickup_type === "1" && row.payment_info?.arrival_charge ? (
                <p className="mb-0 mt-3">
                  <span className="text-muted">
                    {getType(row.payment_info.pickup_type)}:
                  </span>{" "}
                  <span className="fw-medium text-dark">
                    ${row.payment_info.arrival_charge}
                  </span>
                </p>
              ) : null}

              {row.payment_info?.pickup_type === "2" && row.payment_info?.departure_charge ? (
                <p className="mb-0 mt-3">
                  <span className="text-muted">
                    {getType(row.payment_info.pickup_type)}:
                  </span>{" "}
                  <span className="fw-medium text-dark">
                    ${row.payment_info.departure_charge}
                  </span>
                </p>
              ) : null}

              {row.payment_info?.pickup_type === "3" && row.payment_info?.point_point_charge ? (
                <p className="mb-0 mt-3">
                  <span className="text-muted">
                    {getType(row.payment_info.pickup_type)}:
                  </span>{" "}
                  <span className="fw-medium text-dark">
                    ${row.payment_info.point_point_charge}
                  </span>
                </p>
              ) : null}

              {["4", "5"].includes(row.payment_info?.pickup_type) ? (
                <>
                  {row.payment_info?.midnight_charge > 0 && (
                    <p className="mb-0 mt-3">
                      <span className="text-muted">Midnight Surcharge:</span>{" "}
                      <span className="fw-medium text-dark">
                        ${row.payment_info.midnight_charge}
                      </span>
                    </p>
                  )}
                  {row.payment_info?.disposal_charge !== undefined && row.payment_info?.disposal_charge !== null && (
                    <p className="mb-0 mt-3">
                      <span className="text-muted">
                        {getType(row.payment_info.pickup_type)}:
                      </span>{" "}
                      <span className="fw-medium text-dark">
                        ${row.payment_info.disposal_charge}
                      </span>
                    </p>
                  )}
                  {row.payment_info?.extra_disposal_charge > 0 && (
                    <p className="mb-0 mt-0">
                      <span className="text-muted">
                        Extra Hours For Disposal (2 Hrs) :
                      </span>{" "}
                      <span className="fw-medium text-dark">
                        ${row.payment_info.extra_disposal_charge}
                      </span>
                    </p>
                  )}
                </>
              ) : null}

              {["1", "2", "3"].includes(row.payment_info?.pickup_type) ? (
                <>
                  {row.payment_info?.midnight_charge > 0 && (
                    <p className="mb-0 mt-0">
                      <span className="text-muted">Midnight Surcharge:</span>{" "}
                      <span className="fw-medium text-dark">
                        ${row.payment_info.midnight_charge}
                      </span>
                    </p>
                  )}
                  {row.payment_info?.waiting_minutes_charge > 0 && (
                    <p className="mb-0 mt-0">
                      <span className="text-muted">
                        Waiting Time Price (30 Mins):
                      </span>{" "}
                      <span className="fw-medium text-dark">
                        ${row.payment_info.waiting_minutes_charge}
                      </span>
                    </p>
                  )}
                  {row.payment_info?.extra_stop_charge !== undefined && row.payment_info?.extra_stop_charge !== null && (
                    <p className="mb-0 mt-3">
                      <span className="text-muted">
                        Extra Stop Surcharge:
                      </span>{" "}
                      <span className="fw-medium text-dark">
                        ${row.payment_info.extra_stop_charge}
                      </span>
                    </p>
                  )}
                  {row.surcharge_percentage ? (
                    <div>
                      <span className="table-label text-muted">
                        Surcharge Percentage:{" "}
                      </span>
                      <span className="fw-medium text-dark">
                        {row.surcharge_percentage * 25}%
                      </span>
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>
        </div>
      ),
      sortable: true,
    },
  ];

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);

  const filteredItems = reportData.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !== -1
  );

  statusIdentification(filteredItems);
  RidestatusIdentification(filteredItems);
  PaymentstatusIdentification(filteredItems);
  DriverpaymentstatusIdentification(filteredItems);

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleDownloadExcel = (dataSource) => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Payment Report");

      const headerRow = worksheet.addRow(Object.keys(dataSource[0]));
      headerRow.height = 50;

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "C6E2FF" },
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };
      });

      dataSource.forEach((row) => {
        const newRow = worksheet.addRow(Object.values(row));
        newRow.eachCell((cell) => {
          cell.alignment = {
            wrapText: true,
            vertical: "top",
            horizontal: "left",
          };
        });
      });

      worksheet.getColumn(1).width = 10;
      for (let i = 2; i <= headerRow.cellCount; i++) {
        worksheet.getColumn(i).width = 30;
      }

      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Payment-Report.xlsx");
      });
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };

  document.title = "LimoGenie - Driver Report";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Payment Reports" pageTitle="Home" />
        <Card>
          <CardHeader>
            <Row className="g-3">
              <Col xxl={2} md={6}>
                <div>
                  <Label className="mb-1">Advance Search</Label>
                  <div className="search-box ms-0">
                    <Input
                      type="text"
                      className="form-control"
                      id="searchProductList"
                      value={query}
                      onChange={handlequeryChange}
                      placeholder="Search..."
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </div>
              </Col>
              <Col xxl={2} md={6}>
                <div>
                  <Label className="mb-1">Hotel Name</Label>
                  <div className="mb-0">
                    {userType2 === "2" ? (
                      <Input
                        className="mb-0"
                        classNamePrefix="form-control-select"
                        value={loginhotelname}
                        placeholder="Hotel Name"
                        inputId="hotelName"
                        readOnly
                        required
                        style={{
                          userSelect: "none",
                          cursor: "not-allowed",
                          background: "rgba(var(--vz-light-rgb), .75)",
                        }}
                      />
                    ) : (
                      <Select
                        className="mb-0"
                        classNamePrefix="form-control-select"
                        value={selectedHotel}
                        onChange={handleHotelChange}
                        options={hotelOptions}
                        placeholder="Select Hotel Name"
                        inputId="hotelName"
                        required
                      />
                    )}
                  </div>
                </div>
              </Col>
              <Col xxl={2} md={6}>
                <Label className="mb-1">Ride Status</Label>
                <Select
                  className="mb-0"
                  classNamePrefix="form-control-select"
                  defaultValue={executiveNamesList[0]}
                  placeholder="Ride Status"
                  isSearchable={false}
                  onChange={changeStatus}
                  options={executiveNamesList}
                  id="country-select"
                />
              </Col>
              <Col xxl={2} md={6}>
                <Label className="mb-1">Payment Status</Label>
                <Select
                  className="mb-0"
                  classNamePrefix="form-control-select"
                  defaultValue={executiveNamesList1[0]}
                  placeholder="Payment Status"
                  isSearchable={false}
                  onChange={changeStatus1}
                  options={executiveNamesList1}
                  id="country-select"
                />
              </Col>
              <Col xxl={2} md={6}>
                <Label className="mb-1">Payment Type</Label>
                {userType === "2" ? (
                  <Input
                    className="mb-0"
                    classNamePrefix="form-control-select"
                    value={selectedOption}
                    inputId="paymentType"
                    readOnly
                    required
                    style={{
                      userSelect: "none",
                      cursor: "not-allowed",
                      background: "rgba(var(--vz-light-rgb), .75)",
                    }}
                  />
                ) : (
                  <Select
                    className="mb-0"
                    classNamePrefix="form-control-select"
                    defaultValue={executiveNamesList2[0]}
                    placeholder="Payment type"
                    isSearchable={false}
                    onChange={changeStatus2}
                    options={executiveNamesList2}
                    id="country-select"
                  />
                )}
              </Col>
              <Col xxl={2} md={6}>
                <Label className="mb-1">Booking Date Range</Label>
                <div className="input-group">
                  <Flatpickr
                    className="form-control"
                    placeholder="Enter Booking Date Range"
                    options={options}
                  />
                </div>
              </Col>
              <Col>
                <div className="mt-0 pt-0">
                  <Button
                    className="btn btn-info add-btn me-1"
                    onClick={() => handleSubmit()}
                  >
                    Search
                  </Button>
                  <Button
                    href="#"
                    className="btn btn-soft-info add-btn border-1 border_1"
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Row>
          </CardHeader>
        </Card>

        <Card>
          <CardBody className="p-0">
            <Row>
              <Col>
                <DataTable
                  title={<h5 className="mb-0">Payment Report</h5>}
                  className="custom-datatable"
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationServer={true}
                  paginationTotalRows={totalcount}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationComponentOptions={paginationComponentOptions}
                  paginationRowsPerPageOptions={["10", "20", "40"]}
                  noDataComponent={<NoResultData />}
                  selectableRowsVisibleOnly={false}
                  subHeaderAlign="left"
                  contextMenu={true}
                  persistTableHead
                  actions={
                    <Row className="g-4 align-items-start align-items-lg-center flex-column flex-row-lg row">
                      <Col
                        md={12}
                        lg="auto"
                        className="ms-lg-auto no-padding-mobile"
                      >
                        <div className="hstack gap-2 flex-lg-row flex-wrap">
                          {subHeaderComponent}
                          <button
                            type="button"
                            className="btn btn-success w-100-mobile"
                            onClick={() => handleDownloadExcel(exceldata)}
                          >
                            <i className="ri-file-excel-2-fill align-bottom me-1"></i>{" "}
                            Export Excel
                          </button>
                        </div>
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PaymentReport;